import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import WelcomePopup from "./components/WelcomePopup";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CoursesSection from "./components/CoursesSection";
import ResultsSection from "./components/ResultsSection";
import WhyChooseSection from "./components/WhyChooseSection";
import VideoSection from "./components/VideoSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";
import "./App.css";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <WelcomePopup />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CoursesSection />
      <ResultsSection />
      <WhyChooseSection />
      <VideoSection />
      <ContactSection />
      <Footer />
      <FloatingCallButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
